<template>
  <BreadCrumb PageTitle="Nouveaux Client" />
  <AddCustomer />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddCustomer from "@/components/Customers/AddCustomer.vue";

export default defineComponent({
  name: "AddCustomerPage",
  components: {
    BreadCrumb,
    AddCustomer,
  },
});
</script>